import { css } from '@emotion/react'

export const styles = () => ({
  form: {
    main: css``,
    content: {
      main: css``,
      amount: css`
        margin-bottom: 24px;
      `,
      message: css`
        margin-bottom: 24px;
      `,
      submit: css``,
    },
  },
})
